import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import React from 'react'

function DgSwitch({ checked, action }) {

    const CustomSwitch = styled(Switch)(({ theme }) => ({
        width: 42,
        height: 20,
        padding: 0,
        display: 'flex',
        '&:active': {
            '& .MuiSwitch-thumb': {
                width: 20,
            },
            '& .MuiSwitch-switchBase.Mui-checked': {
                transform: 'translateX(16px)',
            },
        },
        '& .MuiSwitch-switchBase': {
            padding: 2,
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#021C2D',
                '& + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: '#FBED96',
                },
            },
        },
        '& .MuiSwitch-thumb': {
            boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
            width: 22,
            height: 16,
            borderRadius: 16,
            color: "#012B45",
            transition: theme.transitions.create(['width'], {
                duration: 200,
            }),
        },
        '& .MuiSwitch-track': {
            borderRadius: 16,
            opacity: 1,
            backgroundColor: '#95B2C5',
            boxSizing: 'border-box',
            transition: 'all .5s ease'
        },
    }));

    return (
        <div>
            <CustomSwitch defaultChecked={checked} inputProps={{ 'aria-label': 'ant design' }} onChange={action} />
        </div>
    )
}

export default DgSwitch